export default __webpack_public_path__ + "static/media/p82.24604a56.jpg";